import { BaseService } from './base.service';
import { Insurance, LinkFamilyPolicyDto } from '@/types/insurance';

class InsuranceService extends BaseService {
  constructor() {
    super('/insurance');
  }

  async createInsurance(data: Insurance) {
    return await this.post<Insurance>('/', data);
  }

  async updateInsurance(id: string, data: Partial<Insurance>) {
    return await this.put<Insurance>(`/${id}`, data);
  }

  async deleteInsurance(id: string) {
    return await this.delete<{ success: boolean }>(`/${id}`);
  }

  // Enhanced endpoint with coveredMember flag
  async getInsuranceByMember(memberId: string) {
    return await this.get<Insurance[]>(`/member/${memberId}`);
  }

  // New endpoint: Link family member to insurance policy
  async linkFamilyMember(insuranceId: string, memberId: string) {
    const payload: LinkFamilyPolicyDto = { memberId };
    return await this.put<Insurance>(`/${insuranceId}/link-family-member`, payload);
  }

  // New endpoint: Get all insurances for a family, optionally excluding a member
  async getInsurancesByFamily(familyId: string, excludeMemberId?: string) {
    const params = new URLSearchParams();
    params.append('familyId', familyId);
    if (excludeMemberId) {
      params.append('memberId', excludeMemberId);
    }
    return await this.get<Insurance[]>(`/family?${params.toString()}`);
  }
}

export default new InsuranceService();
